import tokens from './tokens.json';

export { tokens };

export type BadgeKey = keyof typeof tokens.badge;
export type StatusKey = keyof typeof tokens.statusBadge;

export function badgePerEstat(estat: string): BadgeKey {
  const key = (tokens.statusBadge as Record<string, string>)[estat];
  return (key ?? 'gray') as BadgeKey;
}

export function variablesCss(): Record<string, string> {
  const c = tokens.color;
  const vars: Record<string, string> = {
    '--brand': c.brand.default,
    '--brand-ink': c.brand.ink,
    '--brand-soft': c.brand.soft,
    // Blau marí del logotip BAtech: color de marca. El vermell queda reservat per a «crítica».
    '--navy-900': c.navy['900'],
    '--navy-700': c.navy['700'],
    '--navy-500': c.navy['500'],
    '--navy-50': c.navy['50'],
    '--sidebar-bg': tokens.component.webSidebar.bg,
    '--crisi': c.semantic.crisi,
    '--critic': c.semantic.critic,
    '--incident': c.semantic.incident,
    '--avis': c.semantic.avis,
    '--preventiu': c.semantic.preventiu,
    '--resolt': c.semantic.resolt,
    '--bg': c.background.default,
    '--bg-grouped': c.background.grouped,
    '--bg-page': c.background.page,
    '--bg-critic': c.background.critic,
    '--label': c.label.primary,
    '--label-2': c.label.secondary,
    '--label-3': c.label.tertiary,
    '--label-4': c.label.quaternary,
    '--separator': c.separator.default,
    '--separator-opaque': c.separator.opaque,
    '--fill-1': c.fill.primary,
    '--fill-2': c.fill.secondary,
    '--fill-3': c.fill.tertiary,
    '--font-sans': tokens.font.family.sans,
    '--font-mono': tokens.font.family.mono,
    '--sidebar-width': `${tokens.component.webSidebar.width}px`,
    '--toolbar-height': `${tokens.component.webToolbar.height}px`,
    '--content-padding': `${tokens.component.webContent.padding}px`,
  };
  for (const [k, v] of Object.entries(c.system)) vars[`--${k}`] = v;
  for (const [k, v] of Object.entries(c.gray)) vars[`--gray-${k}`] = v;
  for (const [k, v] of Object.entries(tokens.radius)) vars[`--r-${k}`] = `${v}px`;
  for (const [k, v] of Object.entries(tokens.spacing)) vars[`--sp-${k}`] = `${v}px`;
  for (const [k, v] of Object.entries(tokens.shadow)) vars[`--sh-${k}`] = v;
  for (const [k, v] of Object.entries(tokens.badge)) {
    vars[`--badge-${k}-bg`] = v.bg;
    vars[`--badge-${k}-fg`] = v.fg;
  }
  return vars;
}

export function aplicaTema(root: HTMLElement = document.documentElement): void {
  for (const [k, v] of Object.entries(variablesCss())) root.style.setProperty(k, v);
}
